"use client"

import { Tabs, TabPane } from '@douyinfe/semi-ui';
import './feature-tabs.css';
import { IAgentView, IAgentDemoVO } from '@/types';

export default function AgentTabs({ agentViewList, data }: { agentViewList: IAgentView[], data: any }) {

  const lastTabItem = [
    {
      label: '智能创作',
      agentName: '智能撰写',
      description: '从选题到框架，全程辅助论文初创',
      path: '/chat/paper-assistant?isView=1',
      cover: 'https://minio.wenkoo.com.cn/wenkoo/public/agentDemo/cover/中小学ai教育应用研究.jpg',
      id: '108',
      agentId: '1',
      detailId: '1',
      enableFlag: true,
    },
    {
      label: '智能创作',
      agentName: '汇编创作',
      description: '多篇文章+你的灵感=独一无二的创作，汇编技法一学就会。',
      path: '/chat/user/content?id=682c2a2bfbf57e21d941d68f&type=2&isView=1',
      cover: 'https://minio.wenkoo.com.cn/wenkoo/public/agentDemo/cover/汇编创作logo.jpg',
      id: '109',
      agentId: '1',
      detailId: '1',
      enableFlag: true,
    }
  ]

  function handleDemoClick(item: IAgentDemoVO) {
    if (item.path) {
      return window.open(item.path, '_blank')
    }

    if (!item.agentId) return;

    if (item.enableFlag) {

      if (item.agentType == 5) {
        window.open('/chat/share/report?id=68cbaa2094f7b90acc0baab8', '_blank')
        return;
      }

      window.open('/chat/chat-view?viewId=' + item.detailId + '&agentId=' + item.agentId, '_blank')
    } else {
      if (item.agentType == 4) {
        return;
      }



      window.open('/chat/?agentId=' + item.agentId, '_blank')
    }
  }

  function handleItemClick(item: IAgentDemoVO) {
    if (item.path) {
      return window.open(item.path, '_blank')
    }

    if (item.agentType == 4) {
      window.open('/chat/oral-reading?agentId=' + item.agentId, '_blank');
    } else {
      if (item.agentType == 5) {
        window.open('/chat/modify?agentId=' + item.agentId, '_blank')
        return;
      }
      window.open('/chat/?agentId=' + item.agentId, '_blank')
    }
  }

  function tabComponent(tab: string, content: string): React.ReactNode {
    return (
      <div className='cursor-pointer'>
        <div className='text-lg font-bold text-[#303133]'>{tab}</div>
        <div className='text-sm text-[#606266]'>{content}</div>
      </div>
    )
  }
  function tabPaneAgentComponent(agentViewList: IAgentDemoVO[], isLast: boolean): React.ReactNode {
    return (
      <>
        {[...agentViewList, ...((isLast && !['aloud', 'publish'].includes(data.id)) ? lastTabItem : [])].map((item: IAgentDemoVO, index: number) => (
          <div key={index} className='bg-white shadow-[0_4px_20px_0_rgba(0,0,0,0.1)] rounded-2xl w-full max-w-[430px] h-[210px] p-4 flex items-center justify-between cursor-pointer' onClick={() => handleItemClick(item)}>
            <div className='flex flex-col self-stretch justify-around'>
              <div className="lg:mt-2 relative h-full flex flex-col">
                <div className='font-bold text-[#303133] text-lg mb-1'>{item.agentName}</div>
                <div className='text-[#606266] text-sm'>{item.description}</div>
                {
                  item.enableFlag && (
                    <div className=' text-sm w-[112px] h-[40px] font-bold bg-[#E4E7ED] text-[#303133] rounded-full  items-center justify-center hidden lg:flex  cursor-pointer mt-auto flex-shrink-0' onClick={(e) => {
                      e.stopPropagation()
                      handleDemoClick(item)
                    }}>
                      <span className='font_family icon-Play text-2xl! text-[#303133] mr-1'></span>
                      效果演示
                    </div>
                  )
                }
              </div>
            </div>

            <div className='border border-[#E4E7ED] rounded-lg ml-4 flex-shrink-0'>
              <img className='w-[128px] h-[180px] rounded-lg' src={item.cover}></img>
            </div>
          </div>
        ))}
      </>
    )
  }

  return (
    <>
      <div className='mx-auto max-w-[1140px] hidden lg:block relative'>
        <div className="text-sm text-[#909399] text-right -mb-2 mr-2 flex items-center justify-end cursor-pointer hover:text-[#303133]" onClick={() => {
          window.open(`${window.location.origin}/chat/agent`, '_blank')
        }}>
          更多智能体
          <span className='ml-0.5 w-3 h-3 text-[#909399]'>
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  ><path d="M769.216 511.936c0-3.712-1.152-7.232-1.856-10.88-0.64-2.368-0.64-4.8-1.408-7.04a50.56 50.56 0 0 0-11.136-17.344l-417.28-417.28a48.96 48.96 0 0 0-68.992-0.96 48.832 48.832 0 0 0 1.024 68.864L654.208 512l-384.64 384.768a48.768 48.768 0 0 0-1.024 68.8 48.768 48.768 0 0 0 68.864-0.96l417.28-417.344a51.2 51.2 0 0 0 11.136-17.344c0.896-2.304 0.896-4.736 1.472-7.04 0.768-3.648 1.92-7.232 1.92-10.944z" fill="#909399" p-id="12204"></path></svg>
          </span>
        </div>
        <Tabs tabPosition='left' className='feature-tabs' type='button'>
          {
            agentViewList?.map((item: IAgentView, index: number) => (
              <TabPane
                key={index}
                itemKey={index.toString()}
                tab={tabComponent(item.name, item.description)}
              >
                {tabPaneAgentComponent(item.wkAgentDemoVOS, (index + 1) == agentViewList.length)}
              </TabPane>
            ))
          }
        </Tabs>
      </div>

      <div className="lg:hidden block">
        <div className="w-full pb-20">
          {
            agentViewList?.map((item: IAgentView, index: number) => (
              <div key={index} className='gap-4 flex flex-col items-center justify-center mt-10'>
                <div className='flex flex-col items-center justify-center'>
                  <div className='text-lg font-bold text-[#303133]'>{item.name}</div>
                  <div className='text-sm text-[#606266]'>{item.description}</div>
                </div>
                <div className='flex flex-wrap gap-4 items-center justify-center'>
                  {tabPaneAgentComponent(item.wkAgentDemoVOS, (index + 1) == agentViewList.length)}
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </>
  )
}
